import { connect } from 'react-redux'
import { 
  getViewMode,
  getCurrentPageName
} from '../app/selectors'
import {
  toggleViewMode
} from '../app/actions'
import { getHeroInViewport } from '../hero/selectors'
import ViewToggle from './view-toggle'

const mapStateToProps = state => {
  return {
    currentPageName: getCurrentPageName(state),
    viewMode: getViewMode(state),
    inViewport: getHeroInViewport(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onToggle: () => {
      dispatch(toggleViewMode())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewToggle)


// WEBPACK FOOTER //
// ./src/components/view-toggle/index.js